<template>
  <div class="next-step-setting-instruction">
    <div class="next-step-setting-instruction__slot">
      <slot />
    </div>
    <span
      v-if="showSteps"
      class="next-step-setting-instruction__count"
    >
      Шаг {{ currentStepNumber }}/{{ stepsCount }}
    </span>
    <router-link
      id="settings-button-next-parent"
      v-if="showSteps"
      v-bind:to="nextStepNavigation"
      class="next-step-setting-instruction__button"
    >
      Далее
    </router-link>
  </div>
</template>

<script>
const CREATE_EMPLOYEE_ROLES = 'ClinicPanelEmployeeRoleList';
const CREATE_CABINETS = 'ClinicPanelCabinetList';
const CREATE_EMPLOYEES = 'ClinicPanelEmployeeList';
const VIEW_SCHEDULE = 'ClinicPanelAppointmentSettings';
const FILL_WORK_SCHEDULE = 'ClinicPanelWorkSchedule';
const FILL_PRICE = 'ClinicPanelServicePriceList';
const GENERAL_SETTINGS = 'ClinicPanelSettings';

/**
 * @description Получить доступные шаги.
 * @param availableSteps
 * @returns {Array}
 */
const getSteps = (availableSteps) => [
  {
    isPassed: availableSteps.includes('general-settings'),
    title: 'Общие настройки',
    to: GENERAL_SETTINGS,
  },
  {
    isPassed: availableSteps.includes('create-cabinets'),
    title: 'Кресла',
    to: CREATE_CABINETS,
  },
  {
    isPassed: availableSteps.includes('create-roles'),
    title: 'Роли',
    to: CREATE_EMPLOYEE_ROLES,
  },
  {
    isPassed: availableSteps.includes('create-employees'),
    title: 'Сотрудники',
    to: CREATE_EMPLOYEES,
  },
  {
    isPassed: availableSteps.includes('view-schedule'),
    title: 'Расписание',
    to: VIEW_SCHEDULE,
  },
  {
    isPassed: availableSteps.includes('fill-work-schedule'),
    title: 'График',
    to: FILL_WORK_SCHEDULE,
  },
  {
    isPassed: availableSteps.includes('fill-price'),
    title: 'Прайс',
    to: FILL_PRICE,
  },
].flatMap(({ isPassed, title, to }) => {
  if (isPassed) {
    return [{ title, to }];
  }
  return [];
});

/**
 * @description Компонент следующего шага инструкции.
 */
export default {
  computed: {
    /**
     * @description Индекс текущего шага.
     * @returns {number}
     */
    currentStepIndex() {
      return this.steps.findIndex((step) => step.to === this.currentRouteName);
    },
    /**
     * @description Номер текущего шага.
     * @returns {number}
     */
    currentStepNumber() {
      return this.currentStepIndex + 1;
    },
    /**
     * @description Доступные шаги.
     * @returns {Array}
     */
    steps() {
      return getSteps(this.availableSteps);
    },
    /**
     * @description Общее количество шагов.
     * @returns {number}
     */
    stepsCount() {
      return this.steps.length;
    },
    /**
     * @description Навигация до следующего шага.
     * @returns {Object}
     */
    nextStepNavigation() {
      const step = this.steps[this.currentStepIndex + 1] ?? {};
      return {
        name: step.to,
        params: { initialAvailableSteps: this.availableSteps },
      };
    },
    /**
     * @description Показывать шаги.
     * @returns {boolean}
     */
    showSteps() {
      return this.currentStepNumber < this.stepsCount;
    },
  },
  name: 'NextStepSettingInstruction',
  props: {
    availableSteps: {
      required: true,
      type: Array,
    },
    currentRouteName: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.next-step-setting-instruction {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 165px;
  padding: 15px 22px;
  z-index: 2;
  background-color: white;
  box-shadow: 0px -10px 10px rgba(0, 0, 0, 0.06);
  &__count {
    color: rgba(4, 137, 224, 1);
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
  }
  &__button {
    @include buttons.btn-blue(162px, 32px, 16px);
    text-decoration: none;
    color: #FFFFFF !important;
  }
  &__slot {
    flex: 1;
    margin-right: auto;
  }
}
@media screen and (max-width: 960px) {
  .next-step-setting-instruction {
    left: 0;
    padding: 10px;
    &__count {
      font-size: 16px;
      line-height: 18px;
    }
    &__button {
      @include buttons.btn-blue(162px, 44px, 16px);
    }
  }
}
</style>
